const getCategoryFallbackImage = (category) => {
  const cat = (category || '').toLowerCase();
  if (cat.includes('hoodie')) return '/images/cat-slide-men-hoodie.webp';
  if (cat.includes('women') && cat.includes('polo')) return '/images/cat-slide-women-polo.webp';
  if (cat.includes('women')) return '/images/cat-slide-women-classic.webp';
  if (cat.includes('jersey') || cat.includes('sport')) return '/images/cat-slide-sports-jersey.webp';
  if (cat.includes('oversized')) return '/images/cat-slide-women-hoodies.webp';
  if (cat.includes('shirt')) return '/images/cat-slide-men-classic.webp';
  return '/images/cat-slide-men-polo.webp';
};

export function sanitizeProductsForStorage(products = []) {
  if (!Array.isArray(products)) return [];
  return products.map((product) => {
    if (!product || typeof product !== 'object') return null;
    const sanitized = { ...product };

    // Auto-correct invalid category/gender combinations (e.g. Jersey saved as Polos)
    const pName = (sanitized.name || '').toLowerCase();
    if (sanitized.category === 'Polos' && (pName.includes('jersey') || sanitized.gender === 'Sports')) {
      sanitized.category = 'Sports Jerseys';
      sanitized.gender = 'Sports';
    } else if (sanitized.category === 'Sports Jerseys' || sanitized.category === 'Sports T-Shirts') {
      sanitized.gender = 'Sports';
    }

    const defaultFallback = getCategoryFallbackImage(sanitized.category);

    let rawImg = sanitized.imageUrl || sanitized.image || sanitized.image_url;
    if (rawImg && typeof rawImg === 'object') {
      rawImg = rawImg.preview || rawImg.url || rawImg.filePath || defaultFallback;
    }

    if (!rawImg || typeof rawImg !== 'string' || rawImg.trim() === '') {
      rawImg = defaultFallback;
    }

    sanitized.image = rawImg;
    sanitized.imageUrl = rawImg;

    if (Array.isArray(sanitized.images) && sanitized.images.length > 0) {
      sanitized.images = sanitized.images.map(img => {
        let val = typeof img === 'object' ? (img.preview || img.url || img.filePath) : img;
        if (!val || typeof val !== 'string' || val.trim() === '') {
          return rawImg;
        }
        return val;
      });
    } else {
      sanitized.images = [rawImg];
    }

    return sanitized;
  }).filter(Boolean);
}
